import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'

Vue.use(VueI18n)

const messages = {

  en: {
    ...enLocale,
    options: {
      option: '{label}'
    },
    schedule: {
      tabs: {
        calendar: 'Calendar',
        list: 'List',
        teacher: 'Teacher',
        classroomField: 'Classroom/Field'
      },
      modes: {
        all: 'All',
        part: 'Filtered'
      },
      today: 'Today',
      day: 'Day',
      week: 'Week',
      month: 'Month',
      weekdays: {
        sun: 'Sun',
        mon: 'Mon',
        tue: 'Tue',
        wed: 'Wed',
        thu: 'Thu',
        fri: 'Fri',
        sat: 'Sat'
      },
      picker: {
        monthFormat: 'yyyy-MM',
        weekFormat: 'yyyy Week WW',
        dateFormat: 'yyyy-MM-dd',
        selectMonth: 'Select month',
        selectWeek: 'Select week',
        selectDate: 'Select date',
        startDate: 'Start date',
        endDate: 'End date',
        separator: 'to'
      },
      settings: {
        display: 'Display settings',
        timeRange: 'Schedule time range',
        hideSuspended: 'Hide suspended',
        cellHeight: 'Cell height',
        startTime: 'Start time',
        endTime: 'End time',
        small: 'Small',
        normal: 'Normal',
        large: 'Large'
      },
      actions: {
        download: 'Download schedule'
      },
      filters: {
        byTeacher: 'Filter by teacher',
        byStation: 'Filter by teaching site'
      },
      loading: {
        loading: 'Loading',
        loadingMore: 'Loading...'
      },
      emptyTeacher: 'No teacher',
      moreLessons: '{count} more lessons'
    },
    mediaUpload: {
      image: 'Image',
      video: 'Video',
      audio: 'Audio',
      document: 'Document',
      teacherResources: 'Teacher resources'
    },
    assignmentFormDialog: {
      dialogTitle: 'Assign homework',
      dialogTitleNormal: 'Assign regular homework',
      dialogTitleDaka: 'Assign periodic check-in assignments',
      title: 'Title',
      titlePlaceholder: 'Please enter the assignment title.',
      content: 'Content',
      contentPlaceholder: 'Please enter the assignment content.',
      needSubmit: 'Online submit',
      deadline: 'Submission deadline',
      scoreHomework: 'Grade',
      scoreType: 'Grading method',
      scoreTypeOptions: {
        score: 'Score',
        star: 'Stars',
        level: 'Level'
      },
      starOptions: {
        star3: '3-star',
        star5: '5-star'
      },
      starFull: 'Number of stars',
      starFullPlaceholder: 'Please select',
      fullScore: 'Full score',
      fullPlaceholder: 'Please enter full score',
      sectionStudents: {
        unselected: 'Assign to specific students in this section.',
        selected: 'Send to selected students'
      },

      startDate: 'Start date',
      endDate: 'End date'
    },
    teachContentsDialog: {
      dialogTitle: 'Modify Lesson Topic and Content',
      title: 'Topic',
      titlePlaceholder: 'Enter topic',
      content: 'Content',
      contentError: 'Enter lesson content',
      contentPlaceholder: 'Lesson content or notes(Visible to students)',
      notify: 'Notify students'
    }

  },
  zh: {
    ...zhLocale,
    el: {
      ...zhLocale.el,
      datepicker: {
        ...zhLocale.el.datepicker,
        week: '周次'
      }
    },
    options: {
      option: '{label}'
    },
    schedule: {
      tabs: {
        calendar: '日历',
        list: '列表',
        teacher: '老师',
        classroomField: '教室/场地'
      },
      modes: {
        all: '总课表',
        part: '分课表'
      },
      today: '今天',
      day: '日',
      week: '周',
      month: '月',
      weekdays: {
        sun: '周日',
        mon: '周一',
        tue: '周二',
        wed: '周三',
        thu: '周四',
        fri: '周五',
        sat: '周六'
      },
      picker: {
        monthFormat: 'yyyy 年 MM 月',
        weekFormat: 'yyyy 第 WW 周',
        dateFormat: 'yyyy 年 MM 月 dd 日',
        selectMonth: '选择月',
        selectWeek: '选择周',
        selectDate: '选择日',
        startDate: '开始日期',
        endDate: '结束日期',
        separator: '至'
      },
      settings: {
        display: '显示设置',
        timeRange: '课表时间区间',
        hideSuspended: '隐藏停课',
        cellHeight: '单元格高度',
        startTime: '起始时间',
        endTime: '结束时间',
        small: '小',
        normal: '正常',
        large: '大'
      },
      actions: {
        download: '下载课表'
      },
      filters: {
        byTeacher: '按老师筛选',
        byStation: '按教学点筛选'
      },
      loading: {
        loading: '加载中',
        loadingMore: '加载中...'
      },
      emptyTeacher: '暂无老师',
      moreLessons: '还有{count}节课'
    },
    mediaUpload: {
      image: '图片',
      video: '视频',
      audio: '音频',
      document: '文档',
      teacherResources: '课程资源'
    },
    assignmentFormDialog: {
      dialogTitle: '布置作业',
      dialogTitleNormal: '布置普通作业',
      dialogTitleDaka: '布置定时打卡作业',
      title: '作业标题',
      titlePlaceholder: '输入作业标题',
      content: '作业内容',
      contentPlaceholder: '输入作业内容',
      needSubmit: '需在线提交作业',
      deadline: '作业截止时间',
      scoreHomework: '给作业评分',
      scoreType: '评分方式',
      scoreTypeOptions: {
        score: '分数',
        star: '星级',
        level: '等级'
      },
      starOptions: {
        star3: '三星',
        star5: '五星'
      },
      starFull: '满星数量',
      starFullPlaceholder: '请选择',
      fullScore: '总分',
      fullPlaceholder: '输入总分',
      sectionStudents: {
        unselected: '仅布置给部分学员',
        selected: '发送给部分学员'
      },

      startDate: '开始时间',
      endDate: '结束时间'
    },
    teachContentsDialog: {
      dialogTitle: '修改课节主题和上课内容',
      title: '课节主题',
      titlePlaceholder: '请输入课节主题',
      content: '上课内容',
      contentError: '请输入上课内容',
      contentPlaceholder: '输入本课节上课内容或者备注(学生可见)',
      notify: '是否通知'
    }

  }
}

const supportedLocales = ['zh', 'en']

function normalizeLocale (locale) {
  const language = String(locale || '').toLowerCase().split('-')[0]
  return supportedLocales.includes(language) ? language : ''
}

function getStoredLocale () {
  try {
    return normalizeLocale(window.localStorage.getItem('locale'))
  } catch (error) {
    return ''
  }
}

function setStoredLocale (locale) {
  try {
    window.localStorage.setItem('locale', locale)
  } catch (error) {}
}

function getQueryLocale () {
  try {
    const searchParams = new URLSearchParams(window.location.search)
    return normalizeLocale(searchParams.get('lang') || searchParams.get('locale'))
  } catch (error) {
    return ''
  }
}

function getBrowserLocale () {
  const browserLanguage = typeof navigator === 'undefined' ? '' : navigator.language
  return browserLanguage && browserLanguage.toLowerCase().startsWith('zh') ? 'zh' : 'en'
}

function getInitialLocale () {
  const queryLocale = getQueryLocale()
  if (queryLocale) {
    setStoredLocale(queryLocale)
    return queryLocale
  }
  return getStoredLocale() || getBrowserLocale()
}

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: getInitialLocale(), // set locale
  messages // set locale messages
})

export default i18n
